import React, { Fragment } from "react";

const Header = () => {
  return (
    <Fragment>
      <h1>Hangman</h1>
      <p>Find the hidden word - Enter a letter</p>
    </Fragment>
  );
};

export default Header;
